import './App.css';
import { BrowserRouter as Router } from 'react-router-dom';
import React from 'react';
import Navbar from './components/Navbar/Navbar';
import Home from './components/Home/Home';
import About from './components/About/About';
import Projects from './components/Projects/Projects';
import Resume from './components/Resume/Resume';
import Contact from './components/Contact/Contact';
import Luminary from './components/Polygon_Luminary/luminary'; 
import Footer from './components/Footer/Footer';
import '@fortawesome/fontawesome-free/css/all.min.css';
import { animate, utils } from 'animejs';
import CustomCursor from './components/CustomCursor/CustomCursor';

function App() {
  class StarrySky extends React.Component {
    state = {
      num: 150,
      vw: Math.max(document.documentElement.clientWidth, window.innerWidth || 0),
      vh: Math.max(document.documentElement.clientHeight, window.innerHeight || 0)
    };
    starryNight = () => {
      animate("#sky .star", {
        opacity: [0,1],
        alternate: true,
        translateX: utils.random(-100, 100),
        easing: "linear",
        loop: true,
        delay: (el, i) => 50 * i,
      });
      animate("#sky .star2", {
        opacity: [0,1],
        easing: "linear",
      });
      animate("#sky .star3", {
        opacity: [0,1],
        alternate: true,
        easing: "linear",
        loop: true,
        delay: (el, i) => 50 * i,
      });
    };
    randomRadius = () => {
      return Math.random() * 0.7 + 0.6;
    };
    getRandomX = () => {
      return Math.floor(Math.random() * Math.floor(this.state.vw)).toString();
    };
    getRandomY = () => {
      return Math.floor(Math.random() * Math.floor(this.state.vh)).toString();
    };
    componentDidMount() {
      this.starryNight();
    }
    render() {
      const { num } = this.state;
      return (
        <div id="App">
          <svg id="sky">
            {[...Array(num)].map((x, y) => (
              <circle
                cx={this.getRandomX()}
                cy={this.getRandomY()}
                r={this.randomRadius()}
                stroke="none"
                strokeWidth="0"
                fill="white"
                key={y}
                className="star"
              />
            ))}
             {[...Array(num)].map((x, y) => (
              <circle
                cx={this.getRandomX()}
                cy={this.getRandomY()}
                r={this.randomRadius()}
                stroke="none"
                strokeWidth="0"
                fill="white"
                key={y}
                className="star2"
              />
            ))}
            {[...Array(num)].map((x, y) => (
              <circle
                cx={this.getRandomX()}
                cy={this.getRandomY()}
                r={this.randomRadius()}
                stroke="none"
                strokeWidth="0"
                fill="white"
                key={y}
                className="star3"
              />
            ))}
          </svg>
          
        </div>
      );
    }
  }

  return (
    <Router>
      <div className="App">
        <CustomCursor />
        <StarrySky />
        <Luminary />
        <Navbar />
        <div className="main-content">
          {/* <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/projects" element={<Projects />} />
            <Route path="/resume" element={<Resume />} />
            <Route path="/contact" element={<Contact />} />
          </Routes> */}
          <div id="home">
            <Home />
          </div>
          <div id="about">
            <About />
          </div>
          <div id="projects">
            <Projects />
          </div>
          <div id="resume">
            <Resume />
          </div>
          <div id="contact">
            <Contact />
          </div>
        </div>
        <Footer />
      </div>
    </Router>
  );
}

export default App;
